module.exports = __webpack_public_path__ + "img/voice_2.17e840be.svg";